<template>
  <div>
    <BusinessViewHeader :business="business"
        :is_loading="is_loading"
        :is_owner="is_owner"
        :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Business Products Form"
      id="owner_view_products_add_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="products_form_ref"
      id="products_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextField
        v-model="form.name"
        :validation_rules="form_validation.name"
        label="Name Of Product"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <!-- <TextField
        v-model="form.description"
        :validation_rules="form_validation.description"
        label="Description"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField> -->
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Added Products List"
      id="owner_view_products_list_table"
    ></CardedSectionHeader>
    <CardedDisplay>
      <CardedTable
        :items="items"
        :headers="items_headers"
        :show_description="true"
      >
        <template v-slot:description>
          <p class="text-left ml-4 mr-4">
            This business deals in 
            {{
              items.length == 0
                ? "no products"
                : items.length == 1
                ? " 1 product "
                : items.length + " products "
            }}
          </p>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="remove_item(item)" x-small rounded text color="red">
            <v-icon>mdi-cross</v-icon>
          </v-btn>
        </template>
      </CardedTable>
    </CardedDisplay>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
import TextField from "../../../components/TextField";
export default {
  name: "OwnerBusinessesManageProducts",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedDisplay,
    CardedForm,
    TextField,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      _user: null,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      form: {
        name: "",
        description: "",
      },
      form_validation: {
        name: [
          Utils.validate.is_required("Product name is required"),
          Utils.validate.min_max_length(
            3,
            30,
            "Product name should be between 3 and 30 characters "
          ),
        ],
        description: [
          Utils.validate.max_length(
            60,
            "Description should be less than 60 characters"
          ),
        ],
      },
      items: [],
      items_headers: [
        { text: "Name", value: "name" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 456);
      this.form.name = "Product_" + rnd;
      this.form.description = rnd + " This is our nice product " + rnd;
      this.errors = [];
      this.message = "";
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            this.items = this.business.products;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading owners my business on producsts managment",
            errors
          );
        }
      );
    },
    init_form() {
      this.form.name = "";
      this.form.description = "";
      this.errors = [];
      this.message = "";
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.post_business_product(
        {
          ...this.form,
          business_id: this.business_id,
        },
        (res) => {
          //console.log("Items ", res);
          this.items = res;
          this.$refs.products_form_ref.on_clear_form();
          this.init_form();
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  The product was added successfully";
          this.$refs.products_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.products_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit");
      } else {
        this.init_form();
      }
    },
    remove_item(item) {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.delete_business_product(
        {
          id: item.id,
          business_id: this.business_id,
        },
        (res) => {
          this.items = res;
          this.$refs.products_form_ref.on_clear_form();
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  The product was removed successfully";
          this.$refs.products_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.products_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();

        this.$emit("set-page-attributes", {
      title: "Business Manage Products",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Products",
          disabled: true,
          href: "/owner/businesses/list/view/" + this.business_id + "/products/manage",
        },
      ],
      navbar_cols: 3
    });
    this.init_form();
    this.load_business(this.business_id);

  },
};
</script>